export enum EventsActions {
  OPEN_TOAST = 'openToast',
  CLOSE_TOAST = 'closeToast',
}
export enum EventToastType {
  success = 'success',
  error = 'error',
}
export const TOAST_TIMER_DEFAULT = 6;